import { render, staticRenderFns } from "./ExpertsTab.vue?vue&type=template&id=5add873b&scoped=true"
import script from "./ExpertsTab.vue?vue&type=script&lang=js"
export * from "./ExpertsTab.vue?vue&type=script&lang=js"
import style0 from "./ExpertsTab.vue?vue&type=style&index=0&id=5add873b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add873b",
  null
  
)

export default component.exports